import { FuseAnimate } from "@fuse";
import { Avatar, Card, CardContent, Typography, withStyles } from "@material-ui/core";
import TagBullet from "app/Core/Components/TagBullet/TagBullet";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import clsx from "clsx";
import React from "react";

const styles = () => ({
    card: {
        width: "100%",
        "@media (min-width: 600px)": {
            width: "49%",
        },
        "@media (min-width: 960px)": {
            width: "32%",
        }
    }
});

class EmpresaPessoaCard extends XAPPComponent {

    render() {
        const { classes, data, onClick, getTags } = this.props;
        return (
            <Card elevation={1} className={clsx(classes.card, "h-300 cursor-pointer")} onClick={() => onClick(data)}>
                <CardContent className={clsx("flex flex-col flex-auto overflow-hidden")}>
                    <div className="flex flex-1 flex-col items-center justify-center md:flex-row md:items-center md:justify-start">
                        <FuseAnimate animation="transition.expandIn" delay={300}>
                            <Avatar className="w-96 h-96" src={data.foto ? data.foto : "assets/images/avatars/profile.png"} />
                        </FuseAnimate>
                        <div className="w-full">
                            <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                <TagBullet
                                    className="w-full ml-24 mb-4"
                                    itens={getTags(data)}
                                />
                            </FuseAnimate>
                            <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                <Typography className="md:ml-24 xs:text-center xs:mt-6" color="textSecondary">{data.nome}</Typography>
                            </FuseAnimate>
                        </div>
                    </div>
                </CardContent>
            </Card>
        );

    }
}



export default withStyles(styles, { withTheme: true })(EmpresaPessoaCard);
